import { Stack } from '@mui/system';
import PropTypes from 'prop-types';

import * as Styled from './VerticalFieldset.styles';

export const VerticalFieldset = ({ title, subtitle, boldTitle }) => {
  return (
    <Styled.Wrapper>
        {!boldTitle && (<Styled.Title>{title}</Styled.Title>)}
        {boldTitle && (<Styled.BoldTitle>{title}</Styled.BoldTitle>)}
        <Styled.Subtitle>{subtitle}</Styled.Subtitle>
    </Styled.Wrapper>
  );
};

VerticalFieldset.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired
};
